/**
 * ContainerGroupWarningsMessage
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Message } from 'semantic-ui-react';

// Selectors
import { makeSelectContainerGroupValue } from '../../../../../../../../services/containerGroups/selectors';

interface Props {
    warnings?: string[];
}

export class ContainerGroupWarningsMessage extends React.PureComponent<Props> {
    render() {
        const { warnings } = this.props;
        if (!warnings || !warnings.length) return null;
        return (
            <Message
                warning
                header="There were some warnings returned from SAP"
                list={warnings}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    warnings: makeSelectContainerGroupValue('warnings')
});

export default connect(mapStateToProps)(ContainerGroupWarningsMessage);
